import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "dashcamFilled"
const DashcamFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M15.375 3.938C16.515 3.938 17.438 4.86 17.438 6V18C17.438 19.14 16.514 20.063 15.375 20.063H4.5C3.36 20.063 2.438 19.139 2.438 18V6C2.438 4.86 3.36 3.938 4.5 3.938zM21.335 6.348C21.762 6.078 22.312 6.388 22.312 6.887V17.113C22.313 17.611 21.763 17.923 21.336 17.653L21.333 17.65 18.563 15.887V8.111L21.333 6.349z" />
        </svg>
      }
    </span>
  )
}
export default DashcamFilledIcon
